import React from 'react';

import { AtlStatusValue, RedirectStatus } from 'models/shipments';

import { useCurrentArticle } from '../../DetailsPage/hooks/shipment.hooks';
import { DISCLAIMER_TEST_ID } from './Disclaimer.test-ids';

import styles from './Disclaimer.module.scss';

const Disclaimer: React.FC = () => {
  const { events = [], atlEligible, atlStatus, redirectStatus } = useCurrentArticle() || {};
  const localeDateTime = events?.[0]?.localeDateTime ?? null;
  const redirectFailed = redirectStatus === RedirectStatus.REDIRECT_FAILED;
  const atlRequested = atlStatus === AtlStatusValue.REQUESTED;

  const localTimeFootnote = localeDateTime && (
    <p>
      <sup>1</sup> All times refer to the local time at the location shown.
    </p>
  );

  const safedropFootnote = atlEligible && !redirectFailed && !atlRequested && (
    <p>
      <sup>2</sup> The sender of this parcel has asked us to capture a signature on delivery, but you can waive that
      requirement by choosing to have it left in a safe place if nobody&apos;s home. To learn more, read the&nbsp;
      <a href='https://auspost.com.au/terms-conditions/mypost-safe-drop-terms-and-conditions'>
        MyPost Safe Drop Terms and Conditions
      </a>
      .
    </p>
  );
  return localTimeFootnote || safedropFootnote ? (
    <div className={styles.disclaimerWrapper} data-testid={DISCLAIMER_TEST_ID}>
      {localTimeFootnote}
      {safedropFootnote}
    </div>
  ) : null;
};

export default Disclaimer;
